import PropTypes from 'prop-types'
import cn from 'classnames'

const Timeline = ({ children, single = false }) => {
  return (
    <div>
      <ul
        className={cn('timeline', {
          '-single-item': single,
        })}
      >
        {children}
      </ul>
    </div>
  )
}

Timeline.propTypes = {
  date: PropTypes.string,
  single: PropTypes.bool,
  children: PropTypes.node,
  hidden: PropTypes.bool,
}

export default Timeline
